import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getDeviceOnlineRate, getMonitorList, getOnlineRate, getTwocolorList, getWarningList, getAllStationOnlineRate, getStrongAlarmInfo} from '@apis'
import deviceEnergy from '@assets/img/device-energy.png'
import deviceMonitor from '@assets/img/device-monitor.png'
import deviceNode from '@assets/img/device-node.png'
import deviceTwoColor from '@assets/img/device-twoColor.png'
import deviceBg from '@assets/img/deviceBg.png'

const DeviceOnlineRate = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId, brokerId} = userInfo

    const [power, setPower] = useState(null)
    const [onlinePower, setOnlinePower] = useState(null)
    const [warnPower, setWarnPower] = useState(null)
    const [monitor, setMonitor] = useState(null)
    const [onlineMonitor, setOnlineMonitor] = useState(null)
    const [warnMonitor, setWarnMonitor] = useState(null)
    const [node, setNode] = useState(null)
    const [onlineNode, setOnlineNode] = useState(null)
    const [warnNode, setWarnNode] = useState(null)
    const [twocolor, setTwocolor] = useState(null)
    const [onlineTwocolor, setOnlineTwocolor] = useState(null)
    const [warnTwocolor, setWarnTwocolor] = useState(null)


    // 获取配电柜信息
    async function queryEnergyList() {
      const params = {
        projectId,
        brokerId
      }
      const res = projectId ? await getDeviceOnlineRate(params) : await getAllStationOnlineRate(params)
      if (res) {
        setPower(res.online + res.offline)
        setOnlinePower(res.online)
      }
    }

    // 获取配电柜报警信息
    async function queryWarningList() {
      const params = {
        brokerId,
        projectId,
        pageNo: 1,
        pageSize: 9999
      }
      const res = projectId ? await getWarningList(params) : await getStrongAlarmInfo(params)
      if (res && res.data) {
        const warn = res.data.filter(item => item.r===false)
        setWarnPower(warn.length)
      }
    }

    // 获取监控信息
    async function querytMonitorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        const online = res.data.filter(item => {
          return item.valid==1
        })
        setMonitor(res.data.length)
        setOnlineMonitor(online.length)
        setWarnMonitor(res.data.length-online.length)
      }
    }

    // 获取物联网信息
    async function querytTwoColorList() {
      const params = {
        brokerId,
        pageNo: 1,
        pageSize: 9999,
      }
      const res = await getTwocolorList(params)
      if (res && res.data) {
        const online = res.data.filter(item => {
          return item.onlineStatus==1
        })
        setTwocolor(res.data.length)
        setOnlineTwocolor(online.length)
        setWarnTwocolor(res.data.length-online.length)
      }
    }

    // 获取节点信息  
    async function queryNodeList() {
      const params = {
        brokerId
      }
      const res = await getOnlineRate(params)
      if (res) {
        setNode(res.totalCount)
        setOnlineNode(res.onlineCount)
        setWarnNode(res.totalCount - res.onlineCount)
      }
    }

    useEffect(() => {
      queryEnergyList()
      queryWarningList()
      querytMonitorList()
      querytTwoColorList()
      queryNodeList()
    }, [])
  
    return (
      <div className='ck-index-device'>
        <div className='device-title'>设备在线量</div>
        <img className='device-img' src={deviceBg}/>
        <div className='device-item'>
          <div className='device-top'>
            <div className='device-index'>
              <div className='device-index-left'>
                <img src={deviceEnergy}/>
                <div>配电柜</div>
              </div>
              <div className='device-index-right'>
                <tr className='device-index-tr' style={{color: '#fff'}}>
                  <td>总数</td>
                  <td style={{padding: '0 10px'}}>运行</td>
                  <td>报警</td>
                </tr>
                <tr>
                  <td>{power ? power : 0}</td>
                  <td>{onlinePower ? onlinePower : 0}</td>
                  <td style={{color: 'red'}}>{warnPower ? warnPower : 0}个</td>
                </tr>
              </div>
            </div>
            <div className='device-right'>
              <div className='device-index-left'>
                <img src={deviceMonitor}/>
                <div>监控</div>
              </div>
              <div className='device-index-right'>
                <tr className='device-index-tr' style={{color: '#fff'}}>
                  <td>总数</td>
                  <td style={{padding: '0 10px'}}>运行</td>
                  <td>报警</td>
                </tr>
                <tr>
                  <td>{monitor ? monitor : 0}</td>
                  <td>{onlineMonitor ? onlineMonitor : 0}</td>
                  <td style={{color: 'red'}}>{warnMonitor ? warnMonitor : 0}个</td>
                </tr>
              </div>
            </div>
          </div>
          <div className='device-bottom'>
            <div className='device-index'>
              <div className='device-index-left'>
                <img src={deviceTwoColor}/>
                <div>物联网</div>
              </div>
              <div className='device-index-right'>
                <tr className='device-index-tr' style={{color: '#fff'}}>
                  <td>总数</td>
                  <td style={{padding: '0 10px'}}>运行</td>
                  <td>报警</td>
                </tr>
                <tr>
                  <td>{twocolor ? twocolor : 0}</td>
                  <td>{onlineTwocolor ? onlineTwocolor : 0}</td>
                  <td style={{color: 'red'}}>{warnTwocolor ? warnTwocolor : 0}个</td>
                </tr>
              </div>
            </div>
            <div className='device-index'>
              <div className='device-index-left'>
                <img src={deviceNode}/>
                <div>节点</div>
              </div>
              <div className='device-index-right'>
                <tr className='device-index-tr' style={{color: '#fff'}}>
                  <td>总数</td>
                  <td style={{padding: '0 10px'}}>运行</td>
                  <td>报警</td>
                </tr>
                <tr>
                  <td>{node ? node : 0}</td>
                  <td>{onlineNode ? onlineNode : 0}</td>
                  <td style={{color: 'red'}}>{warnNode ? warnNode : 0}个</td>
                </tr>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default DeviceOnlineRate